export default "__VITE_ASSET__Cws9v0kJ__"